<template>
    <div class="bg-[#23242A] text-white h-screen appheader   overflow-y-auto px-6 pt-6 pb-28">
        <div class="flex xl:flex-row flex-col bg-[#2B2C32]  overflow-y-auto rounded-xl">

            <template v-if="vg_selectedLocation.id">
               <div class="w-full xl:w-1/2">
                <Info/>
              </div>

              <div class="w-full xl:w-1/2">
                <StoreHours/>
              </div>
            </template>
            
            <div class="w-full" v-else>
              <div class="bg-[#2B2C32] rounded-lg px-8 py-[16px]">
                <p  class="text-center text-theme-red">Please select a location from the top left corner.</p>
              </div>
            </div>
          
        </div>
    </div>
</template>

<script lang="ts">
import  { defineComponent , ref} from "vue";
import { mapGetters, mapActions, mapMutations } from "vuex";
import { useSnackbar } from "vue3-snackbar";
import StoreHours from '@/views/Location/LocationInfo/StoreHours.vue';
import Info from '@/views/Location/LocationInfo/Index.vue';

export default defineComponent({
  name: "MessageBanner",
  components: {
    Info,
    StoreHours
  },

  setup() {
    let showComponent = ref(true);
    return {
      showComponent
    }
  },

  computed: {
    ...mapGetters({
      vg_selectedLocation: 'location/selected'
    }),
  },

  watch: {
    'vg_selectedLocation': async function() {
    
    },
  },

  async mounted() {
 
  },

  methods: {
    ...mapActions({
      va_spinner: "spinner/setSpinner",
    })
  }
});
</script>

